import script from "./PrestacaoContasPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PrestacaoContasPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__